import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {GarantiasIdoneasProducto} from '../_models/garantias-idoneas-producto';
import {Observable} from 'rxjs';
import { GarantiasIdoneasTipoProductor} from '../_models/garantias-idoneas-tipo-producto';
@Injectable({
  providedIn: 'root'
})
export class GarantiaIdoneasTipoProductoService{
  private rutServicio = AppSettings.rutServiciosAPL + '/api/garantiasIdoneasTiposProductores';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as GarantiasIdoneasTipoProductor[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as GarantiasIdoneasTipoProductor[] ) );
  }

  listadoPorTipoProducto(id: string) {
    return this.httClient.get( this.rutServicio + '/garantiaIdonea/' + id ).pipe( map( res => res as GarantiasIdoneasTipoProductor[] ) );
  }

  listadoPorTipoProductoActivos(id: string) {
    return this.httClient.get( this.rutServicio + '/garantiaIdonea/' + id + '/enabled').pipe( map( res => res as GarantiasIdoneasTipoProductor[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as GarantiasIdoneasTipoProductor ) );
  }

  crear( regCrear: GarantiasIdoneasTipoProductor ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as GarantiasIdoneasTipoProductor ) );
  }

  actualizar( regActualizar: GarantiasIdoneasTipoProductor ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( segmentoActividades: GarantiasIdoneasTipoProductor[] ): Observable<GarantiasIdoneasTipoProductor[]> {
    segmentoActividades.map( sa => {
      sa.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', segmentoActividades ).pipe( map( res => res as GarantiasIdoneasTipoProductor[] ) );
  }
}
